import { createApp } from 'vue';
import { createPinia } from 'pinia';

import auth from '@lib/plugins/auth';
import '@lib/plugins/axios';
import '@lib/plugins/bootstrap';
import router from '@/router';

// Main layout component from the ef lib
import App from '../../lib/js/layouts/Base.vue';

import '@lib/../assets/fontawesome-pro-7.3.0-web/css/all.min.css';
import '@lib/../assets/fontawesome-pro-7.3.0-web/css/solid.min.css';
import '@lib/../assets/fontawesome-pro-7.3.0-web/css/brands.min.css';

const pinia = createPinia();
const app = createApp(App);

app.use(pinia);
app.use(router);
app.use(auth);

// Internationalization: the lib's plugin starts in the browser language and keeps the one picked
// in the profile menu. See lib/docs/locale.md.
import { merge } from 'lodash-es';

import I18n from '@lib/plugins/i18n';
import lib_locale from '../../lib/js/locale';
import app_locales from '@/locale/index';

app.use(I18n, window.env.app?.env == 'e2e' ? {} : merge(lib_locale, app_locales));

import PrimeVue from 'primevue/config';
app.use(PrimeVue);

// The lib's admin settings, with proERBE's design editor in the design tabs whose letter previews
// draw the design with one Standort: Absender & Gestaltung and Briefpapier
import EfLib from '@lib/eflib';
app.use(EfLib, {
	contributions: {
		slots: {
			'admin.settings': [
				{ id: 'design', replaces: 'design', component: () => import('@/pages/Admin/Settings/Design.vue') },
				{ id: 'letterhead', replaces: 'letterhead', component: () => import('@/pages/Admin/Settings/Design.vue') },
			],
		},
	},
});

import AppBroadcastPlugin from '@lib/plugins/broadcast';
app.use(AppBroadcastPlugin);

import Moment from '@lib/plugins/moment';
app.use(Moment);

// The sidebar is custom and is defined in the app
import Sidebar from '@/sidebar';
app.use(Sidebar);

import Notification from '@lib/plugins/layouts/notification';
app.use(Notification);

import { AppApplicationPlugin } from '@lib/plugins/layouts/application';
app.use(AppApplicationPlugin);

import Filters from '@lib/filters';
app.use(Filters);

if (import.meta.env.DEV) {
	app.config.performance = true;
}

// Opt-in Material layer from the ef library. Loaded before the app's own sheet so the
// proERBE tokens win. Comment it out to fall back to the base eflib design.
// See lib/js/sass/DESIGN.md
import '@lib/sass/app-material.scss';

// proERBE brand layer: typography and the accent tokens. See docs/branding.md.
import '@/sass/pro-erbe.scss';

app.mount('#app');
